import useRequest from '@/websdk/utils/request';

export default (function () {
  const { isRequestSuccessed, data, isLoading, exec } = useRequest({
    url: '/api/material_types',
    name: 'materialCategoryGet',
    method: 'GET'
  });
  return [data || [], exec, isLoading, isRequestSuccessed];
  // }
})